import moment from 'moment'
import { validJobKomiMinWage, retriggerJobKomiMinWageOnChange, prefetchJobKomiMinWage } from './job-komi-min-wage-validator'
import { validJobKomiWorkStartDeadline, retriggerJobKomiWorkStartDeadlineOnChange } from './job-komi-work-start-deadline-validator'
import { validLegalBreakTime, getRequiredLegalBreakMinutes, retriggerDurationValidationOnChange } from './legal-break-time-validator'
import { getJobKomiBreakTimeBandError } from './job-komi-break-time-band-validator'

$(() => {
  if (!$('.js-form-validation').length) {
    return
  }

  moment.locale('ja')

  // 1つ以上エラーがあるかフラグ
  let formValidedAtLeastOnce = false
  // サブミットボタンの文言をキャッシュ
  let cacheSubmitButtonText = ''

  let validForForm = (form) => {
    formValidedAtLeastOnce = true
    // エラーなしか判定
    let noError = true
    // バリデーションするセレクタ
    let validateSelectors = []
    validateSelectors.push('input[type="text"]')
    validateSelectors.push('input[type="password"]')
    validateSelectors.push('input[type="email"]')
    validateSelectors.push('input[type="url"]')
    validateSelectors.push('input[type="number"]')
    validateSelectors.push('input[type="month"]')
    validateSelectors.push('input[type="date"]')
    validateSelectors.push('input[type="datetime-local"]')
    // validateSelectors.push('input[type="file"]') fileはバリデーションしない
    validateSelectors.push('input[type="hidden"]')
    validateSelectors.push('input[type="checkbox"]')
    validateSelectors.push('select')
    validateSelectors.push('textarea')
    let validateTargets = validateSelectors.map((sel) => {
      return sel
    }).join(",")
    // ターゲットごとにバリデーション
    $(form).find(validateTargets).each((i, el) => {
      let valid
      valid = validForField(el)
      if (!valid) {
        noError = false
      }
    })
    // desired_times グループバリデーション
    $(form).find('.js-desired-times-row').each((i, row) => {
      const rules = $(row).data('rules') || []
      const hasPresence = rules.includes('presence')
      const fields = $(row).find('input[type="date"], select').toArray()
      const filledCount = fields.filter(f => !!$(f).val()).length
      const allFilled = filledCount === fields.length
      const allEmpty = filledCount === 0

      // エラーリセット
      fields.forEach(f => { $(f).removeClass('is-invalid border-danger') })
      $(row).find('.js-desired-times-error').remove()

      const addRowError = (message) => {
        fields.forEach(f => { $(f).addClass('is-invalid border-danger') })
        $(row).find('.d-sm-flex').after(`<div class="invalid-feedback js-desired-times-error" style="display:block">${message}</div>`)
        noError = false
      }

      if (hasPresence) {
        if (!allFilled) {
          addRowError('全ての項目を入力してください')
          return
        }
      } else {
        if (!allEmpty && !allFilled) {
          addRowError('全ての項目を入力してください')
          return
        }
      }
      // 開始・終了の逆転チェック（全入力済みの場合のみ）
      if (allFilled) {
        const fromTime = parseInt($(row).find('select[name*="from_time"]').val())
        const toTime = parseInt($(row).find('select[name*="to_time"]').val())
        if (fromTime >= toTime) {
          addRowError('終了時間は開始時間より後に設定してください')
        }
      }
    })

    // single_select（ラジオボタン）グループバリデーション
    $(form).find('.js-single-select-input').each((i, root) => {
      const rules = $(root).data('rules') || []
      $(root).removeClass('is-invalid')
      $(root).find('.js-single-select-input-error').remove()

      if (!rules.includes('presence')) {
        return
      }
      // トグル等で非表示になっている場合はバリデーション対象外
      if ($(root).closest('.js-validate-skip').length > 0) {
        return
      }

      if ($(root).find('input[type="radio"]:checked').length === 0) {
        $(root).addClass('is-invalid')
        $(root).children('.col-sm-9').append('<div class="invalid-feedback js-single-select-input-error" style="display:block">値を選択してください</div>')
        noError = false
      }
    })

    // part（お子様情報など、行の追加・削除ができるフォーム）グループバリデーション
    $(form).find('.js-part-input').each((i, root) => {
      const rules = $(root).data('rules') || []
      $(root).removeClass('is-invalid')
      $(root).find('.js-part-input-error').remove()

      if (!rules.includes('presence')) {
        return
      }
      // トグル等で非表示になっている場合はバリデーション対象外
      if ($(root).closest('.js-validate-skip').length > 0) {
        return
      }

      const validRowCount = $(root).find('.js-part-input-list > .js-part-item').not('.js-validate-skip').length
      if (validRowCount === 0) {
        $(root).addClass('is-invalid')
        $(root).find('.js-add-part-input').after('<div class="invalid-feedback js-part-input-error" style="display:block">1件以上追加してください</div>')
        noError = false
      }
    })

    return noError
  }

  let validForField = (el) => {
    let skip = $(el).closest('form .js-validate-skip').length > 0
    if (skip) {
      return true
    }
    // js-desired-times-row 内のフィールドは個別バリデーションをスキップ
    if ($(el).closest('.js-desired-times-row').length > 0) {
      return true
    }
    let rules = $(el).data('rules')
    let errorMessages = $(el).data('error-messages')
    let value = $(el).val()
    if (!rules) {
      return true
    }
    removeError(el)
    for (let j = 0, len = rules.length; j < len; j++) {
      let rule = rules[j]
      // 個別のエラーメッセージ
      let errorMessage = !!errorMessages ? errorMessages[rule] : null;
      switch (rule) {
        case 'presence':
          if (!validPresent(value, el)) {
            if (!!errorMessages && !!errorMessages.presence) {
              addError(el, errorMessages.presence)
            } else if ($(el).prop('tagName') === 'SELECT') {
              addError(el, '値を選択してください')
            } else if ($(el).prop('type') === 'hidden' && /.*file.*/.test($(el).prop('name'))) {
              addError(el, 'ファイルを選択してください')
            } else if ($(el).prop('type') === 'hidden' && /.*payment_service_card_index.*/.test($(el).prop('name'))) {
              addError(el, 'クレジットカードを選択してください')
            } else {
              addError(el, '値を入力してください')
            }
            return false
          }
          break
        case 'presence-checkbox':
          if (!validPresentCheckbox(value, el)) {
            if (!!errorMessages) {
              addParentError(el, errorMessages)
            } else {
              addParentError(el, '値を入力してください')
            }
            return false
          }
          break
        case 'max':
          if (!validMax(value, el)) {
            let max = $(el).data('max')
            addError(el, `${max}文字以内で入力して下さい`)
            return false
          }
          break
        case 'min':
          if (!validMin(value, el)) {
            let min = $(el).data('min')
            addError(el, `${min}文字以上で入力して下さい`)
            return false
          }
          break
        case 'over':
          if (!validOver(value, el)) {
            let over = $(el).data('over')
            addError(el, `${over}以上を入力して下さい`)
            return false
          }
          break
        case 'less':
          if (!validLess(value, el)) {
            let less = $(el).data('less')
            addError(el, `${less}以下を入力して下さい`)
            return false
          }
          break
        case 'before':
            if (!validBefore(value, el)) {
              addError(el, errorMessages.before)
              return false
            }
            break
        case 'after':
          if (!validAfter(value, el)) {
              addError(el, errorMessages.after)
            return false
          }
          break
        case 'reverse':
            if (!validReverse(value, el)) {
              let label = $($(el).data('reverse')).closest('.form-group').find('label').text()
              addError(el, `${label}より後の日程を選択してください`)
              return false
            }
            break
          case 'reverse-before':
            if (!validReverseBefore(value, el)) {
              let label = $($(el).data('reverse-before')).closest('.form-group').find('label').text()
              addError(el, `${label}より前の日程を選択してください`)
              return false
            }
            break
        case 'less_than_duration':
          if (!validLessThanDuration(value, el)) {
            addError(el, errorMessage || '実働時間を超えています')
            return false
          }
          break
        case 'sum_less_than_duration':
          if (!validSumLessThanDuration(value, el)) {
            addError(el, errorMessage || '休憩時間の合計が実働時間を超えています')
            return false
          }
          break
        case 'legal_break_time':
          if (!validLegalBreakTime(value, el)) {
            const required = getRequiredLegalBreakMinutes(value, el)
            addError(el, errorMessage || `法定休憩時間${required}分以上を満たしていません`)
            return false
          }
          break
        case 'email':
          if (!validEmail(value)) {
            addError(el, 'メールアドレスの形式が不正です')
            return false
          }
          break
        case 'tel':
          if (!validTel(value, el)) {
            addError(el, `電話番号の形式が不正です`)
            return false
          }
          break
        case 'url':
          if (!validUrl(value)) {
            addError(el, 'URlの形式が不正です')
            return false
          }
          break
        case 'password':
          if (!validPassword(value)) {
            addError(el, '半角英数字の組み合わせで入力して下さい')
            return false
          }
          break
        case 'json':
          if (!validJson(value)) {
            addError(el, 'JSON形式で入力して下さい')
            return false
          }
          break
        case 'hiragana':
          if (!validHiragana(value, el)) {
            addError(el, `ひらがなで入力して下さい`)
            return false
          }
          break
        case 'kana':
          if (!validKana(value, el)) {
            addError(el, `カタカナで入力して下さい`)
            return false
          }
          break
        case 'romaji':
            if (!validRomaji(value, el)) {
              addError(el, `ローマ字で入力して下さい`)
              return false
            }
            break
        case 'romaji_upper':
          if (!validRomajiUpper(value, el)) {
            addError(el, `ローマ字(大文字)で入力して下さい`)
            return false
          }
          break
        case 'regex':
          if (!validRegex(value, el)) {
            addError(el, errorMessage || `形式に誤りがあります`)
            return false
          }
          break
        case 'past':
            if (!validPast(value, el)) {
              addError(el, `過去の日付は選択できません`)
              return false
            }
            break
        case 'available_email_domain':
            if (!validAvailableEmailDomain(value, el)) {
              let domains = $(el).data('available-domains')
              addError(el, `このメールアドレスは使用できません。${domains}で終わるメールアドレスのみご利用可能です`)
              return false
            }
            break
        case 'forbidden_email_domain':
            if (!validForbiddenEmailDomain(value, el)) {
              let domain = '@' + value.split('@').slice(-1)[0];
              addError(el, `${domain}は利用できません`)
              return false
            }
            break
        case 'invitation_code':
            if (!validInvitationCode(value, el)) {
              addError(el, errorMessage || `入力内容に誤りがあります`)
              return false
            }
            break
        case 'equal':
          if (!validEqual(value, el)) {
            addError(el, errorMessage || '入力内容が一致しません')
            return false
          }
          break
        case 'min_wage':
          if (!validMinWage(value, el)) {
            const prefectureName = $(el).data('prefecture-name')
            const minWage = $(el).data('min-wage')
            addError(el, errorMessage || `${prefectureName}の最低賃金(${minWage}円)以上を入力してください`)
            return false
          }
          break
        case 'job_komi_min_wage':
          if (!validJobKomiMinWage(value, el)) {
            const prefectureName = $(el).data('job-komi-prefecture-name')
            const minWage = $(el).data('job-komi-min-wage')
            addError(el, errorMessage || `${prefectureName}の最低賃金(${minWage}円)以上を入力してください`)
            return false
          }
          break
        case 'job_komi_break_time_band': {
          const bandError = getJobKomiBreakTimeBandError(value, el)
          if (bandError) {
            addError(el, errorMessage || bandError)
            return false
          }
          break
        }
        case 'job_komi_work_start_deadline':
          if (!validJobKomiWorkStartDeadline(value, el)) {
            addError(el, errorMessage || '勤務開始まで72時間以上空けてください')
            return false
          }
          break
      }
    }
    return true
  }
  let validPresent = (value, el) => {
    return !!value
  }

  let validPresentImage = (value, el) => {
    // ImageFileInputでのみ使用されている
    return !!value
  }

  let validPresentCheckbox = (value, el) => {
    return $(el).is(":checked")
  }

  let validMax = ({ length }, el) => {
    let max = $(el).data('max')
    return length <= parseInt(max)
  }

  let validMin = ({ length }, el) => {
    let min = $(el).data('min')
    return length >= parseInt(min)
  }

  let validOver = (value, el) => {
    return value >= $(el).data('over')
  }

  let validLess = (value, el) => {
    return value <= $(el).data('less')
  }

  let validBefore = (value, el) => {
    if (!value) {
      return true
    }

    // Moment.jsで10000年以降を指定しても4桁に丸められてしまうのでVanilla JSで実装(ISO8601準拠)
    // moment('10000-01-01', 'YYYY-MM-DDTHH:mm').year() -> 1000
    const val = new Date(value)
    const to = new Date($(el).data('before'))
    return val <= to
  }

  let validAfter = (value, el) => {
    if (!value) {
      return true
    }

    // Moment.jsで10000年以降を指定しても4桁に丸められてしまうのでVanilla JSで実装(ISO8601準拠)
    // moment('10000-01-01', 'YYYY-MM-DDTHH:mm').year() -> 1000
    const val = new Date(value)
    const from = new Date($(el).data('after'))
    return val >= from
  }

  let validReverse = (value, el) => {
    if (!value) {
      return true
    }
    let target = $($(el).data('reverse')).val()
    if (!target) {
      return true
    }

    let time = moment(value, "YYYY-MM-DDTHH:mm")
    let targetTime = moment(target, "YYYY-MM-DDTHH:mm")
    return time.isSameOrAfter(targetTime)
  }

  let validReverseBefore = (value, el) => {
    if (!value) {
      return true
    }
    let target = $($(el).data('reverse-before')).val()
    if (!target) {
      return true
    }

    let time = moment(value, "YYYY-MM-DDTHH:mm")
    let targetTime = moment(target, "YYYY-MM-DDTHH:mm")
    return time.isSameOrBefore(targetTime)
  }

  // toggle-form.jsのtoggle-trigger-keyと同様、同じフォーム内の別フィールドを
  // (nameのkey部分を置換して)キー名で参照する。object_nameがモデルによって
  // 変わってもそのまま動く(idを直接指定するreverse系ルールと違い、セレクタを
  // configに書く必要がない)
  let findFieldByKey = (el, key) => {
    let form = $(el).closest('form')
    let name = $(el).attr('name')
    let targetName = name.replace(/\[(?!.*\[).*/, '[' + key + ']')
    return form.find('input[name="' + targetName + '"],select[name="' + targetName + '"]')
  }

  // data-duration-start-key / data-duration-end-key で指定した2つの日時フィールド(datetime-local)から実働時間(分)を算出
  // どちらか未入力の場合はnull(判定不可のため呼び出し元でスキップ)
  let getDurationMinutes = (el) => {
    let startVal = findFieldByKey(el, $(el).data('duration-start-key')).val()
    let endVal = findFieldByKey(el, $(el).data('duration-end-key')).val()
    if (!startVal || !endVal) {
      return null
    }
    let start = moment(startVal, "YYYY-MM-DDTHH:mm")
    let end = moment(endVal, "YYYY-MM-DDTHH:mm")
    // 終了時間が開始時間より前の場合は翌日終了(日跨ぎ)として扱う
    if (end.isBefore(start)) {
      end = end.clone().add(1, 'day')
    }
    return end.diff(start, 'minutes')
  }

  let validLessThanDuration = (value, el) => {
    if (!value) {
      return true
    }
    let duration = getDurationMinutes(el)
    if (duration === null) {
      return true
    }
    return Number(value) <= duration
  }

  let validSumLessThanDuration = (value, el) => {
    if (!value) {
      return true
    }
    let duration = getDurationMinutes(el)
    if (duration === null) {
      return true
    }
    let otherValue = Number(findFieldByKey(el, $(el).data('sum-field-key')).val()) || 0
    return (Number(value) + otherValue) <= duration
  }

  let validTel = (value, el) => {
    if (!value) {
      return true
    }
    if (/-/.test(value)) {
      value = value.replace(/-|[a-z]/g, '')
      $(el).val(value)
    }
    let regex = /^\d{10}$|^\d{11}$/
    return regex.test(value)
  }

  let validEmail = (value) => {
    if (!value) {
      return true
    }
    let regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    return regex.test(value)
  }

  let validUrl = (value) => {
    let regex = /^(?:[^:\/?#]+:)?(?:\/\/[^\/?#]*)?(?:([^?#]*\/)([^\/?#]*))?(\?[^#]*)?(?:#.*)?$/
    return regex.test(value)
  }

  let validRegex = (value, el) => {
    if (!value) {
      return true
    }
    let regex = $(el).data('format')
    // 入力値がformatにマッチしているか
    if (regex) {
      return new RegExp(regex).test(value)
    }
    // 入力値が正規表現として妥当か
    try {
      new RegExp(value)
      return true
    } catch (e) {
      return false
    }
  }

  let validPassword = (value) => {
    let regex = /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/i
    return regex.test(value)
  }

  let validJson = (value) => {
    if (!value) {
      return true
    }
    try {
      JSON.parse(value)
    } catch(e) {
      return false
    }
      return true
  }

  let validKana = (value, el) => {
    return !!value.match(/^[ァ-ヶ０-９0-9ー\-　 ]*$/)
  }

  let validHiragana = (value, el) => {
    return !!value.match(/^[ぁ-んゔ０-９0-9ー\-　 ]*$/)
  }

  let validRomaji = (value, el) => {
    return !!value.match(/^[a-zA-Z０-９0-9ー\-　 ]*$/)
  }

  let validRomajiUpper = (value, el) => {
    return !!value.match(/^[A-Z０-９0-9ー\-　 ]*$/)
  }

  let validPast = (value, el) => {
    // readonly(編集不可)のフィールドは本人が変更できないため、日付経過で過去になってもエラー扱いにしない
    if ($(el).prop('disabled') || $(el).prop('readonly')) {
      return true
    }
    if (!value) {
      return true
    }
    let val = moment(value)
    let now = moment(new Date())
    return val.isSameOrAfter(now)
  }

  let validAvailableEmailDomain = (value, el) => {
    if (!value) {
      return true
    }
    if (!validEmail(value)) {
      return true
    }
    let domains = $(el).data('available-domains')
    if (!domains) {
      return true
    }
    if (domains.length == 0) {
      return true
    }
    for (let i = 0; i < domains.length; i++) {
      if (value.endsWith(`@${domains[i]}`)) {
        return true
      } else if(domains[i] == 'ac.jp' && value.endsWith('.ac.jp')) {
        return true
      } else if(domains[i] == 'jp' && value.endsWith('.jp')) {
        return true
      } else if(domains[i] == 'com' && value.endsWith('.com')) {
      }
    }
    return false
  }

  let validForbiddenEmailDomain = (value, el) => {
    if (!value) {
      return true
    }
    if (!validEmail(value)) {
      return true
    }
    let domains = $(el).data('forbidden-domains')
    for (let i = 0; i < domains.length; i++) {
      if (value.endsWith(`@${domains[i]}`)) {
        return false
      }
    }
    return true
  }

  let validInvitationCode = (value, el) => {
       if (!value) {
      return true
    }
    let code = $(el).data('code')
    if (code != value) {
      return false
    }
    return true
  }

  let validEqual = (value, el) => {
    if (!value) {
      return true
    }
    const targetFieldId = $(el).data('target-field-id')
    if (!targetFieldId) {
      return true
    }
    const originalValue = $(`#${targetFieldId}`).val()
    if (originalValue.length === 0) {
      return true
    }
    return value === originalValue
  }

  let validMinWage = (value, el) => {
    if (!value) {
      return true
    }
    const numericValue = parseInt(value)
    if (isNaN(numericValue)) {
      return true
    }

    const form = $(el).closest('form')
    const prefectureIdSelector = $(el).data('min-wage-prefecture-id-selector') || '[id$="prefecture_id"]'
    const currentPrefectureIdEl = form.find(prefectureIdSelector)
    const currentPrefectureId = currentPrefectureIdEl.val()
    if (!currentPrefectureId.length) {
      return true
    }

    const minWageForCurrentPrefecture = minWagesDataMapGlobal[currentPrefectureId]
    if (!minWageForCurrentPrefecture) {
      return true
    }

    const currentPrefectureName = currentPrefectureIdEl.find('option:selected').text()
    $(el).data('prefecture-name', currentPrefectureName) // 都道府県名をデータ属性に保存
    $(el).data('min-wage', minWageForCurrentPrefecture) // 最低賃金をデータ属性に保存
    if (numericValue < minWageForCurrentPrefecture) {
      return false
    }

    return true
  }

  // 最低賃金データをAPIから取得し、キャッシュする関数
  const fetchMinWagesData = () => {
    // 既にフェッチ中の場合は、そのPromiseを返す
    if (minWagesDataFetchPromise) {
      return minWagesDataFetchPromise
    }
    // データが既に存在する場合はPromise.resolveで返す
    if (minWagesDataMapGlobal) {
        return Promise.resolve(minWagesDataMapGlobal)
    }

    // 初めてフェッチする場合
    minWagesDataFetchPromise = fetch(`/api/v1/m_min_wages`)
      .then(response => response.json())
      .then(apiResponse => {
        const minWagesArray = apiResponse.m_min_wages
        minWagesDataMapGlobal = {}
        if (minWagesArray.length) {
          minWagesArray.forEach(item => {
            minWagesDataMapGlobal[item.prefecture_id] = item.min_wage
          })
        }
        return minWagesDataMapGlobal
      })
      .catch(error => {
        console.error('min_wage API fetch error:', error)
        minWagesDataMapGlobal = null // エラー時はキャッシュをクリア
        return null
      })
      .finally(() => {
        minWagesDataFetchPromise = null // フェッチ完了
      })
    return minWagesDataFetchPromise
  }

  let addError = (el, message) => {
    $(el).addClass('is-invalid')
    $(el).closest('.form-group').addClass('is-invalid')
    $(el).addClass('border-danger')
    return $(el).after(`<div class="invalid-feedback">${message}</div>`)
  }

  let addParentError = (el, message) => {
    $(el).addClass('is-invalid')
    $(el).closest('.form-group').addClass('is-invalid')
    $(el).addClass('border-danger')
    return $(el).parent().after(`<div class="invalid-feedback">${message}</div>`)
  }

  let removeError = (el) => {
    $(el).removeClass('is-invalid')
    $(el).closest('.form-group').removeClass('is-invalid')
    $(el).removeClass('border-danger')
    $(el).parent().parent().children().remove('.invalid-feedback')
    return $(el).parent().children().remove('.invalid-feedback')
  }

  // フォーム変更検知
  let onChangeField = (el) => {
    // console.log('onChange')
    let form = $(el.target).closest('form')
    setTimeout(() => {
      // 都道府県変更時に最低賃金バリデーションを再実行
      const changedField = $(el.target)
      const minWageEl = form.find('input[data-rules*="min_wage"]')
      if (minWageEl.length && minWageEl.val().length) {
        // 最低賃金バリデーション対象のフィールドがある場合、都道府県変更時に最低賃金を検証する
        const prefectureIdSelector = minWageEl.data('min-wage-prefecture-id-selector') || '[id$="prefecture_id"]'
        if (changedField.is(prefectureIdSelector) && changedField.val().length) {
          minWageEl.trigger('change')
        }
      }

      // ジョブコミ独自: 施設・基準日(勤務日)変更時に時給の最低賃金バリデーションを再実行
      retriggerJobKomiMinWageOnChange(form, changedField)

      // ジョブコミ独自: 開始時間変更時に勤務開始日時の締切バリデーションを再実行
      retriggerJobKomiWorkStartDeadlineOnChange(form, changedField)

      // 開始・終了時間等、実働時間バリデーション(休憩時間関連)の依存フィールド変更時に再実行
      retriggerDurationValidationOnChange(form, changedField)

      if (formValidedAtLeastOnce) {
        validForForm(form)
      } else {
        validForField(el.target)
      }
      afterValid(form)
    }, 300)
  }

  let afterValid = (form) => {
    $(form).find('.js-validate-skip .is-invalid').removeClass('is-invalid')

    let hasError = $(form).find('.is-invalid').length > 0

    if (hasError) {
      disavailableSubmit(form)
    } else {
      availableSubmit(form)
    }
  }

  let scrollFirstError = (form) => {
    if (!$(form).find('.is-invalid').length) {
      return
    }
    const offset = 100;
    const position = $(form).find('.is-invalid').offset().top;
    const speed = 200;
    $("html,body").animate({ scrollTop: position - offset}, speed);

  }

  let submit = (e) => {
    // ローディング開始
    setBtnLoading(e.target)

    setTimeout(() => {
      let form = $(e.target).closest('form')

      validForForm(form)
      afterValid(form)

      $(form).find('.js-validate-skip .is-invalid').removeClass('is-invalid')

      if ($(form).find('.is-invalid').length > 0) {
        scrollFirstError(form)
        stopBtnLoading(e.target)
        return
      }

      beforeSubmit(form)

      // 下書き保存でない場合の処理
      if ($(e.target).attr('name') == 'revision') {
        $('.js-form-validation').append('<input type="hidden" name="revision" value="true" />')
      }

      form.submit()
    }, 100)
  }

  let setBtnLoading = (el) => {
    let submitBtn = $(el)
    submitBtn.prop('disabled', true)
    submitBtn.addClass('disabled')
    cacheSubmitButtonText = submitBtn.text()
    submitBtn.text('')
    return submitBtn.append(
      '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'
    )
  }

  let stopBtnLoading = (el) => {
    let submitBtn = $(el)
    submitBtn.prop('disabled', false)
    submitBtn.removeClass('disabled')
    submitBtn.text(cacheSubmitButtonText)
  }

  let availableSubmit = (form) => {
    $(form).find('.submit').prop('disabled', false)
    $(form).find('.submit').removeClass('disabled')
  }

  let disavailableSubmit = (form) => {
    $(form).find('.submit').prop('disabled', true)
    $(form).find('.submit').addClass('disabled')
  }

  let beforeSubmit = (form) => {
    // submitをdisable
    disavailableSubmit(form)
    // toggle_trigger_keyがある場合はsubmit前に値を消す
    $('.js-toggle-form').each((i, elm) => {
      let input = $(elm).find('input[name],select[name],textarea[name]')
      let name = input.attr('name')
      let triggerKey = $(elm).data('toggle-trigger-key')
      // partなど、対象フィールドと異なる名前空間（simple_fields_for）でinputが
      // 生成されるケースでは、トグル対象自身のinput名からトリガー名を正規表現推測
      // できないため、明示的なトリガー名(data-toggle-trigger-name)があれば優先する
      let triggerName = $(elm).data('toggle-trigger-name') || name.replace(/\[(?!.*\[).*/, '[' + triggerKey + ']')
      let trigger = form.find('input[name="' + triggerName + '"],select[name="' + triggerName + '"]')
      let viewableLabelData = $(elm).data('toggle-viewable-label')
      let unviewableLabelData = $(elm).data('toggle-unviewable-label')
      let viewableLabels = viewableLabelData ? viewableLabelData.split(',') : null
      let unviewableLabels = unviewableLabelData ? unviewableLabelData.split(',') : null

      if (!viewableLabels && !unviewableLabels) {
        // toggle_viewable_label/toggle_unviewable_labelがどちらも未設定の場合は常に表示扱いにする
        return
      }

      if (trigger.hasClass('js-multiple-select-value')) {
        // checkbox
        let checkedLabels = trigger.parent().find('input:checked').parent().find('label')
        let checked
        if (unviewableLabels) {
          checked = true
          checkedLabels.each((i, label) => {
            let checkedLabel = $(label).text()
            if (unviewableLabels.includes(checkedLabel)) {
              checked = false
            }
          })
        } else {
          checked = false
          checkedLabels.each((i, label) => {
            let checkedLabel = $(label).text()
            if (viewableLabels.includes(checkedLabel)) {
              checked = true
            }
          })
        }
        if (!checked) {
          input.val('')
        }
      } else {
        // radio
        let checkedLabel = trigger.closest('.form-group').find('input:checked').closest('span').find('label').text()
        if (!checkedLabel) {
          // select
          checkedLabel = trigger.closest('.form-group').find('option:selected').text()
        }
        let checked = unviewableLabels ? !unviewableLabels.includes(checkedLabel) : viewableLabels.includes(checkedLabel)
        if (!checked) {
          input.val('')
        }
      }
    })
  }

  // フォーム変更
  // VueのフォームはハッカしないのでvalidFormのタイミングで適当なフォームにjqueryイベントを発生させる。
  // ex)
  // new Vue({
  //   el: id,
  //   data: {
  //     rules: $(id).data('rules'), // Validルール
  //     errors: [], // Validエラーメッセージ
  //   },
  //   mounted() {
  //     $('.js-form-validation .submit').on('click', (e) => {
  //       this.validForm()
  //     })
  //   },
  //   methods: {
  //     validForm() {
  //       if (!this.rules || this.rules.length == 0) {
  //         // 未定義はリターン
  //         return
  //       }
  //       this.errors = []
  //       if (!this.url || this.url == '') {
  //         this.errors.push("ファイルを選択してください")
  //       }
  //       $(id).find('input').trigger('change')
  //     },
  //     onValueUpdate() {
  //       this.validFrom()
  //     }
  //   }
  // })
  //
  //
  // .my-3.invalid-feedback.is-invalid v-for="error in errors"
  //   | {{error}}
  //
  // 全都道府県の最低賃金データをキャッシュ
  let minWagesDataMapGlobal = null
  // 進行中のAPIフェッチのPromiseを保持
  let minWagesDataFetchPromise = null

  // 予め最低賃金データを取得しておく
  const minWageEl = $('.js-form-validation').find('input[data-rules*="min_wage"]')
  const prefectureIdSelector = minWageEl.data('min-wage-prefecture-id-selector') || '[id$="prefecture_id"]'
  const prefectureIdEl = $('.js-form-validation').find(prefectureIdSelector)
  if (minWageEl.length && prefectureIdEl.length) {
    fetchMinWagesData()
  }

  // ジョブコミ独自: 予め最低賃金データを取得しておく(施設・基準日が入力済みの場合のみ)
  prefetchJobKomiMinWage()

  $('.js-form-validation').on('blur keyup change', 'input, select, textarea', (el) => {
    onChangeField(el)
  })

  // フォーム変更検知(js-multile-checkbox)
  $('.js-form-validation').on('click', '.js-multiple-checkbox .checkbox, .js-hierarchy-checkbox .checkbox', (el) => {
    onChangeField(el)
  })

  // フォーム削除検知(coccon)
  // 削除の検知ができず、submitが非活性になるのを防ぐ
  $('.js-form-validation').on('click', '.js-cocoon-remove', (e) => {
    let form = $(e.target).closest('form')
    afterValid(form)
  })

  // フォーム追加・削除検知(profile-part)
  // partの行数(presenceルール)を再判定するため、追加・削除のたびにグループバリデーションを再実行する
  $('.js-form-validation').on('click', '.js-add-part-input, .js-remove-part-input', (e) => {
    let form = $(e.target).closest('form')
    if (formValidedAtLeastOnce) {
      validForForm(form)
    }
    afterValid(form)
  })

  // サブミット
  $('.js-form-validation .submit').on('click', (e) => {
    e.preventDefault()

    submit(e)
  })

  // 下書き
  $('.js-form-validation .draft').on('click', ({ target }) => {
    setBtnLoading(target)
    let form = $(target).closest('form')
    $('.js-form-validation').append('<input type="hidden" name="draft" value="true" />')
    form.submit()
  })
})
